import { render, staticRenderFns } from "./FairManagement.vue?vue&type=template&id=57b9ae73&scoped=true&"
import script from "./FairManagement.vue?vue&type=script&lang=js&"
export * from "./FairManagement.vue?vue&type=script&lang=js&"
import style0 from "./FairManagement.vue?vue&type=style&index=0&id=57b9ae73&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57b9ae73",
  null
  
)

export default component.exports